module.exports = __webpack_public_path__ + "assets/expand-black.479c0027a7f85e3765840cd51457c3dc.svg";